// src/redux/slices/settingsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: {}
};

const serviceSettingsSlice = createSlice({
  name: 'serviceSettings',
  initialState,
  reducers: {
    updateServiceSettingValue: (state, action) => {
        //console.log("action in slice",action);
        
      const { key, value } = action.payload;
      state.value[key] = value;
    },
    clearServiceSettingValue: (state) => {
        //console.log("clearservice---",state);
        
      state.value = {};
    }
  }
});

export const { updateServiceSettingValue, clearServiceSettingValue } = serviceSettingsSlice.actions;
export default serviceSettingsSlice.reducer;
